export const MESSAGES = 'messages'
export const CONTENT_TYPE = ['prefecture', 'city']
